import { useUserStore } from '@base/store/userStore'
import getDistance from 'geolib/es/getDistance'

type Geom = { lat: number; lon: number }

export function createDistanceContent(clubGeom: Geom, currentGeom?: Geom) {
  const userGeom = useUserStore().addressGeom

  if (clubGeom && clubGeom.lat && clubGeom.lon) {
    if (currentGeom && currentGeom.lat && currentGeom.lon) {
      const distance = Math.floor(
        getDistance(
          { latitude: currentGeom.lat, longitude: currentGeom.lon },
          { latitude: clubGeom.lat, longitude: clubGeom.lon }
        ) / 1000
      )
      return `${distance} KM` // current location
    } else if (userGeom && userGeom.lat && userGeom.lon) {
      const distance = Math.floor(
        getDistance(
          { latitude: userGeom.lat, longitude: userGeom.lon },
          { latitude: clubGeom.lat, longitude: clubGeom.lon }
        ) / 1000
      )
      return `${distance} KM` // query location
    }
  }

  return ''
}
